// Tracks which heading (by CSS selector) is currently in view; returns a ref with its id.
// Call `observe()` after the content has rendered (v-html), `disconnect()` on unmount.
import { ref, onBeforeUnmount } from 'vue'

export function useActiveHeading(selector, rootEl) {
  const activeId = ref('')
  let observer = null
  const disconnect = () => { if (observer) { observer.disconnect(); observer = null } }
  const observe = () => {
    disconnect()
    if (typeof IntersectionObserver === 'undefined') return
    const root = (rootEl && rootEl.value) || document
    const headings = [...root.querySelectorAll(selector)]
    if (!headings.length) return
    observer = new IntersectionObserver((entries) => {
      const visible = entries.filter(e => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)
      if (visible.length) activeId.value = visible[0].target.id
    }, { rootMargin: '0px 0px -60% 0px', threshold: 0 })
    headings.forEach(h => observer.observe(h))
  }
  onBeforeUnmount(disconnect)
  return { activeId, observe, disconnect }
}
